module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_gogovan","prefix":"about_hire_job_opportunity"},{"type":"sections/about/about_hire","prefix":"about_hire"}],"about_gogovan":{"headline_style":true},"about_hire_job_opportunity":{"headline_style":true,"show_button":true},"about_map":{},"about_help":{}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/tw/setting/about/setting.json
// module id = 728
// module chunks = 0 1 2 3 4 5